export default __webpack_public_path__ + "static/media/send.b0318ca7.svg";